import TSettingBusinessHoursEditHoliday from './index.vue';

TSettingBusinessHoursEditHoliday.install = app => {
  app.component(TSettingBusinessHoursEditHoliday.name, TSettingBusinessHoursEditHoliday);
};

export default TSettingBusinessHoursEditHoliday;
